import Link from "next/link";
import { memo, ReactNode } from "react";
import { AheadCaretIcon } from "../../icon/AheadCaretIcon";
import { Text } from "../../typography/Text";
import { Button } from "../Button";
import styles from "./styles.module.scss";

type Props = {
  href: string;
  children: string | JSX.Element;
  isExternalLink?: boolean;
};

const LinkComponent = memo(
  ({
    isExternalLink,
    children,
    href,
  }: {
    isExternalLink: Props["isExternalLink"];
    href: Props["href"];
    children: ReactNode;
  }) => {
    return isExternalLink ? (
      <a href={href} rel="noreferrer" target="_blank">
        {children}
      </a>
    ) : (
      <Link href={href}>{children}</Link>
    );
  }
);

export const NavigationButton = memo(
  ({ href, children, isExternalLink }: Props) => {
    return (
      <LinkComponent href={href} isExternalLink={isExternalLink}>
        <Button
          buttonType="buttonColorFrameless"
          px="space-0"
          buttonContainerClassName={styles.navigationButton}
        >
          <div className={styles.navigationButtonInner}>
            <Text size="size-16" className={styles.text}>
              {children}
            </Text>
            <AheadCaretIcon />
          </div>
        </Button>
      </LinkComponent>
    );
  }
);
